import { GeoImageService as OvermapGeoImageService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class GeoImageService extends OvermapGeoImageService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
